<template>

  <!-- Aside Image Tile Element -->
  <page-block
    no-body
    wrapper-class="row wrap"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    class="aside-image-tile-element">

    <page-block
      overlay-class="sbs-pb"
      wrapper-class="aside-image-tile-element__wrapper"
      class="aside-image-tile-element__body col-12 col-md-6">

      <!-- Title -->
      <h2
        v-if="hasTitle">
        {{ value.title.ru }}
      </h2>

      <!-- Body -->
      <div
        v-if="hasBody"
        v-html="value.body.ru"
        class="aside-image-tile-element__body fr-view"/>

      <!-- Buttons -->
      <page-block-buttons
        :value="value.buttons"
        class="aside-image-tile-element__buttons"/>

    </page-block>

    <file-background
      :ratio="16/9"
      v-if="hasFile"
      :value="value.file"
      class="col-12 col-md-6"/>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import FileBackground from '@src/components/file/file-background';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'aside-image-tile-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      FileBackground,
      PageBlockButtons,
    },
    computed: {
      imageStyles() {

        const url = this.getFileUrl(
          this.value.file,
          1200,
          '/images/placeholder/image.png',
        );

        return {
          backgroundImage: `url('${url}')`,
        };
      },
    },
  };

</script>

<style lang="scss">

  .aside-image-tile-element {
    color: inherit;

    &__body {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &:nth-child(even) .row {
      flex-direction: row-reverse;
    }

    @media (max-width: $breakpoint-sm) {

      & .row {
        flex-direction: column-reverse !important;
      }
    }

    &__buttons {
      margin-top: $spacer-md;
    }

    &__wrapper > * {
      margin-bottom: 0;
    }

    &__wrapper > *:not(:first-child) {
      margin-top: $spacer-md;
    }
  }

</style>
